//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex' // 引入mapState
// import { messageHandling } from '~/config/backMessage'
import userHeader from '~/components/login/userHeader.vue' // 头部
import userTabs from '~/components/login/userTabs.vue' // tab
import userCountry from '~/components/login/userCountry.vue' // 国家
import wikiGeet from '~/components/common/wikiGeet.vue' // 极验
import userVerificacode from '~/components/login/userVerificacode.vue' // 验证码
import userVoicevercode from '~/components/login/userVoicevercode.vue' // 语音验证码
import userThreparty from '~/components/login/userThreparty.vue' // 三方登录
import userGraphical from '~/components/login/userGraphical.vue' // 图形验证码
export default {
  components: {
    'user-header': userHeader,
    'user-tabs': userTabs,
    'user-country': userCountry,
    'wiki-geet': wikiGeet,
    'user-verificacode': userVerificacode, // 验证码
    'user-voicevercode': userVoicevercode, // 语音验证码
    'user-threparty': userThreparty, // 三方登录
    'user-graphical': userGraphical // 图形验证码
  },
  layout: 'common',
  data () {
    return {
      firstLoad: true, // 是否为首次加载该组件
      LanguageCode: this.$store.state.LanguageCode, // 当前页面语言
      // title: this.$v('登录'), // title
      tabs: [
        { name: this.$v('手机验证码'), type: 1 },
        { name: this.$v('电子邮件/手机号'), type: 2 }
      ],
      mobileNumber: (this.$store.state.host.includes('wikifx') ? 2 : 1), // 点击tab栏状态改变 1 为手机验证码 2为电子邮箱/手机号 3为验证码验证
      verificationCode: 1, // 1为获取手机验证码 2为获取语音验证码
      // 验证码登录
      roTade: false, // 国家点击下拉框状态
      phoneSize: false, // 请输入手机号样式漂浮状态
      clearButton: false, // 清空
      phoneLoading: false, // 加载动画显示
      showDrag: false, // 是否展示极验拖拽框
      // 邮箱/手机号登录
      emailNumber: false, // 电子邮件或手机号样式状态
      emailpasswordNumber: false, // 电子邮件或手机号密码样式状态
      openState: false, // 手机号邮箱登录密码状态切换 true 显示 false 关闭为密码模式
      // 登录数值绑定
      signin: {
        cellhoneNumber: '', // 验证码登录手机号绑定
        formatError: '', // 手机号验证码登录错误提示
        mailorPhone: '', // 邮箱or手机号账号绑定
        mailorPhoneword: '', // 邮箱手机号密码登录
        mailorError: '', // 账号密码登录错误提示
        requestId: '', // 验证码发送后的requestId
        isregistered: null // 手机号是否注册
      },
      voiceState: true, // 是否展示语音验证
      countOrnot: true, // 是否展示倒计时
      isVercode: false, // 是否校验验证码
      product: 'popup', // 极验展示效果
      canIskip: false // 是否出现跳过
    }
  },
  computed: {
    ...mapState(['usergetCountry']), // 选中的国家
    title () { // 标题
      switch (this.mobileNumber) {
        case 1:
          return this.$v('登录')
        case 2:
          return this.$v('登录')
        case 3:
          return this.$v('验证码')
        case 4:
          return this.$v('语音验证')
        default:
          return this.$v('无头')
      }
      // return this.mobileNumber == 1 || this.mobileNumber == 2 ? this.$v('登录') : this.$v('验证码')
    }
  },
  watch: {
    roTade (newV) { // 监听国家下拉框
      if (!newV || !this.firstLoad) return false // 收起或非首次展开下拉框时，不执行后续操作
      this.firstLoad = false // 当首次展开下拉框时，需要执行以下操作，后续无需执行
      this.$nextTick(() => {
        // this.$refs.userCountry._scrollInit()
        this.$refs.userCountry.getHeight()
      })
    },
    'signin.cellhoneNumber': {
      handler (val) {
        // console.log('val: ', val)
        if (val && this.mobileNumber == 1) {
          // console.log('填入')
          this.clearButton = true // 清空按钮and下一步按钮
          // console.log('this.清空按钮and下一步按钮clearButton: ', this.clearButton)
        } else if (!val) {
          this.clearButton = false // 清空按钮and下一步按钮
        }
      }
      // deep: true,
      // immediate: true
    },
    'signin.mailorPhone' (val) {
      if (val && this.signin.mailorPhoneword && this.mobileNumber == 2) {
        this.clearButton = true // 清空按钮and下一步按钮
      } else if (!val) {
        this.clearButton = false // 清空按钮and下一步按钮
      }
    },
    'signin.mailorPhoneword' (val) {
      if (val && this.signin.mailorPhone && this.mobileNumber == 2) {
        this.clearButton = true // 清空按钮and下一步按钮
      } else if (!val) {
        this.clearButton = false // 清空按钮and下一步按钮
      }
    },
    usergetCountry: {
      handler (newValue, oldValue) {
        this.signin.formatError = ''
      },
      deep: true
      // immediate: true
    }
    // '$store.state.drawerStatus' (newV) {
    //   console.log('newV:登录 ', newV)
    //   if (!newV) this.switstat(this.$store.state.host.includes('wikifx') ? 2 : 1)
    // }
  },
  created () {
    // console.log(this.usergetCountry)
    // console.log(this.$route.path.substring(this.$route.path.lastIndexOf('/') + 1)) // login.html
  },
  mounted () {
    document.addEventListener('click', this.coutryClose)
    // this.$nextTick(() => {
    //   document.querySelector('.wiki-head').style.display = 'none  !important'
    // })
  },
  beforeDestroy () {
    document.removeEventListener('click', this.coutryClose)
  },
  // beforUpdate () {
  //   this.reset()
  // },
  methods: {
    threSwitch () {
      this.switstat(this.$store.state.host.includes('wikifx') ? 2 : 1)
      this.$emit('loginSwitch', 2)
    },
    loginSwitch (i) { // 切换显示框
      this.mobileNumber = i
    },
    jumpgender () {
      this.$emit('verCode', '')
      this.$emit('setRequestId', this.signin.requestId)
      this.$emit('cellphoneNumber', this.signin.cellhoneNumber)
      this.$emit('loginSwitch', 2) // 切换注册流程
    },
    // // 重置本组件
    // reset () {
    //   // this.phoneVal = this.searchVal = '' // 清空手机号输入框、清空搜索框
    //   this.roTade = false // 隐藏下拉框
    //   console.log('this.roTade: ', this.roTade)
    //   this.firstLoad = true
    //   console.log('this.firstLoad: ', this.firstLoad)
    // },
    getPhonecode (data = {}) { // 获取验证码
      // this.mobileNumber = 1 // 切换为手机验证码
      this.showDrag = false
      // this.product = 'bind'
      this.sendVCode(data) // 获取验证码
    },
    geetError () { // 极验错误
      this.showDrag = false // 极验框状态取消
      this.mobileNumber = 5 // 出现图形验证码
    },
    coutryClose (e) { // 点击非组件区域关闭下拉框
      if (!this.$el.contains(e.target)) this.roTade = false
    },
    close () { // 清除按钮
      this.signin.cellhoneNumber = this.signin.formatError = '' // 手机输入内容为空/手机错误提示为空
      this.phoneSize = false // 请输入手机号样式为false
      this.phoneLoading = false // 加载动画为false
    },
    switstat (i) { // tab栏切换
      // console.log('进入清空')
      this.signin.cellhoneNumber = this.phoneLoading = this.signin.mailorPhone = this.signin.mailorPhoneword = this.signin.formatError = this.signin.mailorError = '' // 手机号验证码登录绑定清空 // 邮箱手机号密码登录绑定清空 // 邮箱or手机号账号绑定清空
      this.phoneSize = this.emailNumber = this.emailpasswordNumber = this.showDrag = false // 请输入手机号样式状态false // 电子邮件或手机号样式状态false // 电子邮件或手机号密码样式状态false
      this.mobileNumber = i // 显示状态  1为手机验证码  2为手机号/邮箱登录
      this.roTade = false // 国家隐藏
    },
    logoIn () { // 下一步|登录
      if (this.mobileNumber == 1 && this.signin.cellhoneNumber != '') { // 为1则是手机号验证码
        this.phoneLoading = true
        // 1.5秒后loading关闭
        setTimeout(() => {
          this.phoneLoading = false
        }, 800)
        this.getVercode() // 校验手机格式后获取验证码
      } else if (this.mobileNumber == 2 && this.signin.mailorPhone != '' && this.signin.mailorPhoneword != '') {
        this.accpassLogin() // 账号密码登录
      }
    },
    getVercode () { // 校验手机号格式后获取验证码
      if (this.usergetCountry.code == '0086') { // 如果为国内则走国内手机号验证
        if (!this.signin.cellhoneNumber) {
          return (this.signin.formatError = this.$v('用户手机号有误'))
        }
        const myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
        if (myreg.test(this.signin.cellhoneNumber)) {
          // console.log('验证手机号成功')
          this.signin.formatError = '' // 验证成功则错误消息清空
          this.numberRis() // 手机号校验
        } else {
          this.signin.formatError = this.$v('手机号格式错误')
        }
      } else { // 否则走国外手机号验证
        if (!this.signin.cellhoneNumber) {
          return (this.signin.formatError = this.$v('用户手机号有误'))
        }
        const myreg = /^.{5,20}$/
        if (myreg.test(this.signin.cellhoneNumber)) {
          // console.log('国外手机号验证成功')
          this.signin.formatError = '' // 验证成功则错误消息清空
          this.numberRis() // 手机号校验
        } else {
          this.signin.formatError = this.$v('手机号格式错误')
        }
      }
    },
    async numberRis () { // 手机校验是否注册之后是否发送验证码国内国际逻辑
      // console.log('进入手机校验')
      const { cellhoneNumber = '' } = this.signin // 手机号为空true/false
      if (!cellhoneNumber) return false
      // 校验手机号是否注册
      const { succeed = false, extra = '', result = {} } = await this.$api.login.userCheckphone({ areaCode: this.usergetCountry.code, phoneNumber: this.signin.cellhoneNumber })
      if (!succeed) return this.$message.error(extra) // 数据错误
      this.signin.isregistered = result.isregister // 该手机号是否注册
      if (result.isregister) { // 手机注册过则出现极验
        this.showDrag = true // 极验框展示
      } else if (this.usergetCountry.code == '0086') { // 手机未注册为86则出现极验
        this.canIskip = true // 未注册且为0086则出现跳过
        this.showDrag = true // 极验框展示
      } else { // 不为86则直接跳注册流程
        this.$emit('cellphoneNumber', this.signin.cellhoneNumber) // 发送当前输入的手机号
        this.$emit('loginSwitch', 2) // 切换注册流程
      }
    },
    async sendVCode (data = {}) { // 极验成功后发送验证码
      const { cellhoneNumber = '' } = this.signin // 手机号为空true/false
      if (!cellhoneNumber) return false
      // 校验手机号是否注册
      // const { succeed = false, extra = '', result = {} } = await this.$api.login.userCheckphone({ areaCode: this.usergetCountry.code, phoneNumber: this.signin.cellhoneNumber })
      this.showDrag = false // 隐藏拖拽框
      // 发送验证码/语音验证码
      // const { succeed = false, extra = '', result = {} } = await this.$api.login.userVercode({ areaCode: this.usergetCountry.code, phone: this.signin.cellhoneNumber, languageCode: this.LanguageCode, msgType: this.verificationCode == 1 ? 0 : 1, smsBusinessType: 1, applicationType: 7, GeetestValidate: data.geetest_validate, GeetestChallenge: data.geetest_challenge })
      // if (!succeed) return this.$message.error(extra) // 数据错误
      // this.signin.requestId = result.requestid
      // this.verificationCode = 1 // 修改为验证码获取 verificationCode
      // // this.$message({
      // //   message: this.$v('验证码发送成功'),
      // //   type: 'success'
      // // })
      // // 跳转验证码
      // this.mobileNumber = 3

      const res = await this.$api.common
        .CV3(
          {
            areaCode: this.usergetCountry.code,
            phone: this.signin.cellhoneNumber,
            languageCode: this.LanguageCode,
            msgType: this.verificationCode == 1 ? 0 : 1,
            smsBusinessType: 1,
            applicationType: 7,
            GeetestValidate: data.geetest_validate,
            GeetestChallenge: data.geetest_challenge,
            captcha_output: data.captcha_output,
            lot_number: data.lot_number,
            pass_token: data.pass_token,
            gen_time: data.gen_time
          },
          {
            Routes: 'usercenter$sendcodegeettest4'
          }
        )
        .catch(() => {
          console.log('sendcodegeettest4')
        })

      const rest = res?.usercenter?.sendcodegeettest4
      console.log('rest::: ', rest)
      if (rest?.success) {
        this.verificationCode = 1 // 修改为验证码获取 verificationCode
        this.signin.requestId = rest?.data?.requestid || ''
        this.mobileNumber = 3
      } else {
        this.$message.error(rest?.extra)
      }
    },
    async setVercode (data) { // 图形验证成功后发送验证码
      const { cellhoneNumber = '' } = this.signin // 手机号为空true/false
      if (!cellhoneNumber) return false
      // 校验手机号是否注册
      // const { succeed = false, extra = '', result = {} } = await this.$api.login.userCheckphone({ areaCode: this.usergetCountry.code, phoneNumber: this.signin.cellhoneNumber })
      this.showDrag = false // 隐藏拖拽框
      // 发送验证码/语音验证码
      // const { succeed = false, extra = '', result = {} } = await this.$api.login.userVercode({ areaCode: this.usergetCountry.code, phone: this.signin.cellhoneNumber, languageCode: this.LanguageCode, msgType: this.verificationCode == 1 ? 0 : 1, smsBusinessType: 1, applicationType: 7, GeetestValidate: '', GeetestChallenge: '', graphCode: data })
      // if (!succeed) return this.$message.error(extra) // 数据错误
      const res = await this.$api.common
        .CV3(
          {
            areaCode: this.usergetCountry.code,
            phone: this.signin.cellhoneNumber,
            languageCode: this.LanguageCode,
            msgType: this.verificationCode == 1 ? 0 : 1,
            smsBusinessType: 1,
            applicationType: 7,
            GeetestValidate: data.geetest_validate,
            GeetestChallenge: data.geetest_challenge,
            captcha_output: data.captcha_output,
            lot_number: data.lot_number,
            pass_token: data.pass_token,
            gen_time: data.gen_time
          },
          {
            Routes: 'usercenter$sendcodegeettest4'
          }
        )
        .catch(() => {
          console.log('sendcodegeettest4')
        })

      const rest = res?.usercenter?.sendcodegeettest4
      console.log('rest::: ', rest)
      if (rest?.success) {
        this.signin.requestId = rest?.data?.requestid || ''
        this.mobileNumber = 3
      } else {
        this.$message.error(rest?.extra)
      }
    },
    voiceVerification () { // 跳转语音获取验证码
      this.mobileNumber = 4 // 修改为语音验证码弹框
      // this.verificationCode = 2// 修改为语音验证码获取
      // this.getVercode() // 出现极验
    },
    voiceTran () { // 语音获取验证码
      // console.log('进入语音验证码')
      this.countOrnot = false // 展示 获取验证码
      this.mobileNumber = 3 // 修改为手机号弹框
      this.verificationCode = 2// 修改为语音验证码获取
      this.$nextTick(() => {
        this.$refs.userverificacode.getweebgeet() // 调用极验
      })
      // this.getVercode() // 出现极验
    },
    voiceClose () { // 语音获取取消
      this.countOrnot = false // 取消倒计时
      this.mobileNumber = 3 // 跳转为验证码
    },
    async getUsertion (code) { // 验证码成功之后登录
      if (this.signin.isregistered) { // 判断该手机号是否注册 注册过直接登录
        const { succeed = false, extra = '', result = {} } = await this.$api.login.userQuicklogin({
          areaCode: this.usergetCountry.code, // 国家code
          phone: this.signin.cellhoneNumber, // 手机号
          msgCode: code, // 验证码
          requestId: this.signin.requestId, // 极验之后的requestId
          // account: this.signin.cellhoneNumber, // 账号
          version: 124, // 版本号
          applicationType: 7, // 项目类型
          countryCode: this.usergetCountry.countryCode, // 国家code
          languageCode: this.LanguageCode, // 页面语言
          ip: this.$store.state.userIp // 用户ip
        })
        // this.$message.success('adfb ')
        if (!succeed) return this.$message.error(extra) // 数据错误
        console.log('result: ', result)
        // this.$store.commit('setUser', {
        //   userId: result.userId,
        //   nick: result.nick,
        //   avatar: result.avatar
        // })
        this.accessCookie(result) // 加密cookie存cookie
      } else {
        // 校验验证码是否正确
        const { succeed = false, extra = '' } = await this.$api.login.userVerifysms({ AreaCode: this.usergetCountry.code, PhoneNumber: this.signin.cellhoneNumber, Smscode: code, ApplicationType: 7, ValidateSmsCodeType: 3, LanguageCode: this.LanguageCode })
        if (!succeed) return this.$message.error(extra) // 数据错误
        this.$emit('verCode', code)
        this.$emit('setRequestId', this.signin.requestId)
        this.$emit('cellphoneNumber', this.signin.cellhoneNumber)
        this.$emit('loginSwitch', 2) // 切换注册流程
      }
    },
    async accpassLogin () { // 账号密码登录
      const { succeed = false, extra = '', result = {} } = await this.$api.login.userAccpass({
        account: this.signin.mailorPhone, // 账号
        password: this.signin.mailorPhoneword,
        version: 124, // 版本号
        loginType: this.signin.mailorPhone.includes('@') ? 1 : 0, // 0为手机 1为邮箱
        applicationType: 7, // 项目类型
        countryCode: this.usergetCountry.countryCode, // 国家code
        languageCode: this.LanguageCode, // 页面语言
        ip: this.$store.state.userIp // 用户ip
      })
      if (!succeed) return (this.signin.mailorError = extra) // 数据错误
      this.signin.mailorError = ''
      this.accessCookie(result) // 加密cookie存cookie
    },
    async accessCookie (userInfo) { // 加密cookie存cookie
      this.$store.commit('setUser', {
        userId: userInfo.userId,
        nick: userInfo.showNickName || userInfo.nick,
        avatar: userInfo.showAvataraddress || userInfo.avatar
      })
      const { succeed = false, extra = '', result = {} } = await this.$api.login.userEncryption({
        userId: userInfo.userId,
        nick: userInfo.showNickName || userInfo.nick,
        avatar: userInfo.showAvataraddress || userInfo.avatar
      })
      if (!succeed) return this.$message.error(extra) // 数据错误
      if (this.$store.state.host.includes('wikifx')) {
        this.CookieSet(
          'DJkdikKMG',
          result.Value,
          `.${this.$store.state.host.split('.')[1]}.${this.$store.state.suffix}`
        )
      } else if (this.$store.state.host.includes('fxeye')) {
        this.CookieSet(
          'ViLartidlakd',
          result.Value,
          `.${this.$store.state.host.split('.')[1]}.${this.$store.state.suffix}`
        )
      } else {
        this.$cookies.set('WsdsfgDGdagYms', result.Value)
        // this.CookieSet(
        //   'WsdsfgDGdagYms',
        //   result.Value,
        //   `.${this.comurl}.${this.$store.state.my_domin}`
        // )
        const postdata = {
          op_type: 'setCookie',
          url: '',
          parm: result.Value
        }
        // console.log(123);
        window.parent.postMessage(postdata, '*')
      }
      console.log('存cookie')
      // this.$message.success('登录成功')
      // 如果为login.html页面则跳转
      // if (this.$store.state.path == 'login.html') {
      //   this.$store.commit('setUCookie', result?.Value)
      //   setTimeout(() => {
      //     location.href = `/${this.$store.state.LanguageCode}/usercenter/index.html`
      //   }, 200)
      // } else {
      this.$store.commit('setUsercookie', result?.Value)
      // const postdata = {
      //   op_type: 'reload',
      //   url: '',
      //   parm: ''
      // }
      // window.parent && window.parent.postMessage(postdata, '*')
      this.$emit('close')
      // }
      if (this.$store.state.path.includes('login.html')) {
        setTimeout(() => {
          if (process.client) location.href = `/${this.$store.state.LanguageCode}/usercenter/index.html`
        }, 200)
      }
    },
    CookieSet (key, val, dom) { // 存cookie
      const expiresTime = new Date(Date.now() + 8.64e7 * 999)
      this.$cookies.set(key, val, {
        expires: expiresTime,
        path: '/',
        domain: dom
      })
    }
  }
}
